import { Skeleton } from '@/components/ui/skeleton';

interface SkeletonLoaderProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  margin?: string;
  backgroundColor?: string;
  variant?: 'rectangular' | 'circular';
}

/**
 * The bone color the MUI theme gave a skeleton with no color of its own:
 * the heading ink at 11%, so it follows the light and dark themes.
 */
export const THEMED_SKELETON_BACKGROUND =
  'color-mix(in srgb, var(--type-heading) 11%, transparent)';

// A block `<span>`, so a loader can sit inside a `<p>` or a `<span>`.
const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  width = '100%',
  height = '200px',
  borderRadius = '.5rem',
  margin = '0',
  backgroundColor = 'rgba(255,255,255,.05)',
  variant = 'rectangular',
}) => {
  return (
    <Skeleton
      asChild
      className="block"
      animation="wave"
      width={width}
      height={height}
      style={{
        backgroundColor,
        borderRadius: variant === 'circular' ? '100%' : borderRadius,
        margin,
      }}
    >
      <span />
    </Skeleton>
  );
};

export default SkeletonLoader;
